module.exports = __webpack_public_path__ + "img/app_logo_mini.751afbe4.png";